var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.499962 12.149C0.499962 12.4806 0.631657 12.7985 0.866077 13.0329C1.1005 13.2673 1.41844 13.399 1.74996 13.399H31.2325L23.365 21.264C23.1302 21.4988 22.9984 21.8171 22.9984 22.149C22.9984 22.481 23.1302 22.7993 23.365 23.034C23.5997 23.2688 23.918 23.4006 24.25 23.4006C24.5819 23.4006 24.9002 23.2688 25.135 23.034L35.135 13.034C35.2514 12.9179 35.3437 12.78 35.4067 12.6281C35.4698 12.4763 35.5022 12.3135 35.5022 12.149C35.5022 11.9846 35.4698 11.8218 35.4067 11.67C35.3437 11.5181 35.2514 11.3802 35.135 11.264L25.135 1.26404C25.0187 1.14782 24.8808 1.05563 24.7289 0.992732C24.5771 0.929834 24.4143 0.897461 24.25 0.897461C23.918 0.897461 23.5997 1.02932 23.365 1.26404C23.1302 1.49876 22.9984 1.8171 22.9984 2.14904C22.9984 2.48098 23.1302 2.79932 23.365 3.03404L31.2325 10.899H1.74996C1.41844 10.899 1.1005 11.0307 0.866077 11.2652C0.631657 11.4996 0.499962 11.8175 0.499962 12.149Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconRightArrow);
export default __webpack_public_path__ + "static/media/TH-Icon-RightArrow.81058cce3d2231a19ed04089440c4845.svg";
export { ForwardRef as ReactComponent };